import { render, staticRenderFns } from "./InsInform.vue?vue&type=template&id=8e7f746a&scoped=true&"
import script from "./InsInform.vue?vue&type=script&lang=ts&"
export * from "./InsInform.vue?vue&type=script&lang=ts&"
import style0 from "./InsInform.vue?vue&type=style&index=0&id=8e7f746a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8e7f746a",
  null
  
)

export default component.exports